import { useMemo } from "react";
import { useSearchParams } from "next/navigation";

import { capitalizeFirst, joinNames } from "../utils/content/text";

interface CatNames {
  allCatNames: string;
  allCatNamesCapitalized: string;
}

export const useCatNamesFromQuery = (): CatNames => {
  const searchParams = useSearchParams();

  const [ allCatNames, allCatNamesCapitalized ] = useMemo(() => {
    const param = searchParams.get("allCatNames");
    if (Array.isArray(param)) {
      return [ joinNames(param), joinNames(param.map((name) => capitalizeFirst(name))) ];
    } if (typeof param === "string" && param.trim()) {
      const names = param.split(",");
      return [ joinNames(names), joinNames(names.map((name) => capitalizeFirst(name))) ];
    }
    return [ "your cat", "Your cat" ];

  }, [ searchParams ]);

  return {
    allCatNamesCapitalized,
    allCatNames,
  };
};
